import { z } from '@qred/components-library';
import { NLAddressLookupSchema } from '~/components/shared/NLAddressLookup/NLAddressLookup';
import { requiredString } from '~/helpers/schema.helper';

// Deliberately duplicated (not imported) from PersonalInformation.schema.ts
// — see the comment in StartApplicationNew.schema.ts for why.
// NLAddressLookupSchema is left as a shared import: it's a general-purpose
// utility already reused by DE/NL today, not something this experiment
// introduces a duplicate concept of.
const firstAndLastNameSchema = z.object({
  firstName: requiredString(),
  lastName: requiredString(),
});

const dateOfBirthSchema = z.date({
  required_error: 'ValidationErrors.Required',
});

export const AboutYouSchema = z.object({
  ...firstAndLastNameSchema.shape,
  dateOfBirth: dateOfBirthSchema,
  ...NLAddressLookupSchema.shape,
});

export type AboutYouForm = z.infer<typeof AboutYouSchema>;
